import { render, staticRenderFns } from "./CapitalHumano.vue?vue&type=template&id=3550b2b6&"
import script from "./CapitalHumano.vue?vue&type=script&lang=js&"
export * from "./CapitalHumano.vue?vue&type=script&lang=js&"
import style0 from "./CapitalHumano.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports